import {
  axios_nomination,
} from '@/plugins/axios';
import configuration from '@/configurations';

class HistoryRepository {

  /**
   * @param {Object} criteria
   *
   * @returns {Promise}
   */
  async searchHistory(criteria) {
    const result = await axios_nomination.post(
      `${configuration.api_host}/v2/histories/search`,
      criteria
    );

    return result.data;
  }

  /**
   * @param {Object} criteria
   *
   * @returns {Promise}
   */
  async searchHistoryByCriteriaObject(criteria) {
    const result = await axios_nomination.post(
      `${configuration.api_host}/v2/histories/search-by-objects`,
      criteria
    );

    return result.data;
  }

  /**
   * @param {Object} data
   *
   * @returns {Promise}
   */
  async createHistory(data) {
    const result = await axios_nomination.post(
      `${configuration.api_host}/v2/histories`,
      data
    );

    return result.data;
  }

  /**
   * @param {Object} input
   *
   * @returns {Promise}
   */
  async bulkCreateHistories(input) {
    const result = await axios_nomination.post(
      `${configuration.api_host}/v2/histories/bulk`,
      input
    );

    return result.data;
  }

  /**
   * @param {Number} history_id
   *
   * @returns {Promise}
   */
  async deleteHistory(history_id) {
    const result = await axios_nomination.delete(
      `${configuration.api_host}/v2/histories/${history_id}`
    );

    return result.data;
  }
}

const history_repository = new HistoryRepository();

export {
  history_repository,
};
